import CloseIcon from "@mui/icons-material/Close";
import { Box, Dialog, DialogContent, IconButton } from "@mui/material";
import i18n from "../../../../utils/i18n";

const CalComDialog = ({ open, onClose, url }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      PaperProps={{
        sx: {
          height: "86vh",
          display: "flex",
          flexDirection: "column",
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          flexShrink: 0,
          px: 0.5,
          pt: 0.5,
        }}
      >
        <IconButton aria-label={i18n.t("general.closebutton")} onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </Box>
      <DialogContent sx={{ p: 0, flex: 1, minHeight: 0, overflow: "hidden" }}>
        {url ? (
          <iframe
            title="Cal.com booking"
            src={url}
            style={{ width: "100%", height: "100%", border: 0 }}
            allow="clipboard-write; microphone; camera"
          />
        ) : null}
      </DialogContent>
    </Dialog>
  );
};

export default CalComDialog;
